export const formatDate = (date: string, omit?: string) => {
  const newDate = new Date(date);
  const month = newDate.toLocaleString("default", { month: "short" });
  const day = newDate.getDate();
  const year = newDate.getFullYear();
  return `${month} ${day} ${omit === "year" ? "" : year}`;
};
